<template>
  <div class="main-page page-mediaion-case">
    <Menu
      :title="title"
      :home="true"
    />
    <div class="container-flex main-block">
      <div class="left-nav">
        <div
          :class="['item','txtone',index==current?'active':'']"
          v-for="(navitem ,index) in typelist"
          @click="getData(navitem,index)"
          :key="'key-nav'+index"
        >
          {{navitem.title}}
        </div>
      </div>
      <div class="right-con">
        <div class="list-box">
          <div class="list-title">
            {{typetitle}} > 全部
          </div>
          <div
            class="item"
            v-for="(item,index) in typechildlist"
            @click="getDetail(item)"
            :key="'key-d'+index"
          >
            <div class="imgs">
              <img
                src="/img/ui/yasfcase.png"
                width="43"
                alt=""
              >
            </div>
            <div class="intro ">
              <div class="title txtone">
                {{item.title}}
              </div>
              <div class="desc">
                时间：{{item.date}}
                <span>
                  •
                </span>
                {{item.view_count}}次浏览
              </div>
            </div>
          </div>
        </div>
        <div class="hotlist">
          <div class="prevtitle">
            大家都在看
          </div>
          <div
            class="newsitem"
            @click="getDetail(news)"
            v-for="(news,index) in hotlist"
            :key="'key--'+index"
          >
            <div class="num">
              {{(index+1)}}
            </div>
            <div class="newstitle txtetc">
              {{news.title}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rightslide
      v-model="slide"
      @getClose="getClose"
    >
      <template slot="content">
        <div class="title">
          {{article.title}}
        </div>
        <div
          class="detail"
          v-html="article.detail"
        >
        </div>
      </template>
    </Rightslide>
  </div>
</template>
<script>
import Menu from '../../components/Menu'
import Rightslide from '../../components/RightSlide'
import api from '../../datas/js/api.js'
import { MEDIATION_CASE } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menu,
    Rightslide
  },
  data () {
    return {
      title: '调解案例库',
      typetitle: '',
      slide: {
        show: false
      },
      typelist: [],
      typechildlist: [],
      hotlist: [],
      current: 0,
      article: ''
    }
  },
  methods: {
    getClose () {
      this.slide.show = false
    },
    async getData (item, index) {
      if (index || index === 0) {
        this.current = index
      }
      this.getHot(item.id)
      this.typetitle = item.title
      const { status, result, msg } = await this.$get(api.list + item.id)
      if (!status) {
        console.log(msg)
        return
      }
      this.typechildlist = result.data.items
    },
    async getDetail (item) {
      const res = await this.$get(api.post + item.id + `&machine_id=${this.$store.state.device.point.no}&platform=ZD`)
      this.slide.show = true
      this.article = res.result.data
    },
    async getHot (id) {
      const { status, result, msg } = await this.$get('/pufa/api/post/list/?per_page=5&diagram_id=' + id, this)
      if (!status) {
        console.log(msg)
        return
      }
      console.log(result)
      this.hotlist = result.data.items
      // this.typelist = hasechild ? result.data.children : result.data.items
    }
  },
  async mounted () {
    this.$root.getStatistics(MEDIATION_CASE)
    const { id, hasechild } = this.$route.query
    const { status, result, msg } = await this.$get(api.list + id, this)
    if (!status) {
      console.log(msg)
      return
    }
    console.log(hasechild, 'hasechild')
    this.typelist = hasechild ? result.data.children : result.data.items
    this.getData(this.typelist[this.current])
    this.getHot(this.typelist[this.current].id)
  }
}
</script>
<style lang="stylus">
.page-mediaion-case {
  .main-block {
    flex: 1;
    overflow: hidden;
    padding: 0.3rem 0.6rem;
    display: flex;
    .left-nav {
      width: 3.2rem;
      height: 100%;
      margin-right: 0.4rem;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
      .item {
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.26rem;
        color: rgba(255, 255, 255, 0.9);
        padding: 0 0.35rem;
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 0.08rem;
        border: solid 1px rgba(255, 255, 255, 0.2);
        margin-bottom: 0.05rem;
        &.active {
          background: #f29530;
        }
      }
    }
    .right-con {
      display: flex;
      height: 100%;
    }
    .list-box {
      width: 9.8rem;
      margin-right: 0.2rem;
      border-radius: 0.1rem;
      background: #fff;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
      .list-title {
        height: 0.74rem;
        border-radius: 0.1rem 0.1rem 0 0;
        font-size: 0.24rem;
        line-height: 0.74rem;
        background-color: #fff;
        padding: 0 0.34rem;
        border-bottom: 1px solid #e5e5e5;
        color: #333333;
      }
      .item {
        position: relative;
        background: #fff;
        padding: 0.25rem 0.35rem;
        box-sizing: border-box;
        display: flex;
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0.35rem;
          right: 0.35rem;
          border-bottom: 1px solid #e5e5e5;
        }
        &:last-child {
          border-radius: 0 0 0.1rem 0.1rem;
        }
        .imgs {
          width: 0.9rem;
          height: 0.9rem;
          border-radius: 50%;
          margin-right: 0.16rem;
          background-color: #edf3ff;
          text-align: center;
          line-height: 0.9rem;
          flex-shrink: 0;
        }
        .intro {
          padding-right: 0.3rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow: hidden;
          span {
            color: #ccc;
            padding: 0 0.1rem;
          }
        }
        .title {
          font-size: 0.24rem;
          color: #333333;
          line-height: 1;
          width: 100%;
          margin-bottom: 0.2rem;
        }
        .desc {
          font-size: 0.18rem;
          color: #666666;
          line-height: 1;
        }
      }
    }
    .hotlist {
      width: 4.4rem;
      height: 100%;
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 0.1rem;
      border: solid 1px rgba(255, 255, 255, 0.2);
      .title {
        font-size: 0.22rem;
        color: #fff;
        font-weight: 600;
        padding: 0.28rem 0.18rem;
      }
      .taglist {
        display: flex;
        padding: 0 0.08rem;
        flex-wrap: wrap;
        .item {
          height: 0.54rem;
          line-height: 0.54rem;
          margin: 0 0.05rem 0.1rem 0.05rem;
          font-size: 0.2rem;
          color: #fff;
          padding: 0 0.22rem;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 0.08rem;
        }
      }
      .prevtitle {
        padding: 0.3rem 0 0.2rem 0.18rem;
        font-size: 0.22rem;
        color: #fff;
        font-weight: 600;
      }
      .newsitem {
        display: flex;
        align-items: center;
        margin: 0 0.18rem;
        padding: 0.2rem 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        .num {
          border: 1px solid #fff;
          border-radius: 50%;
          width: 0.3rem;
          height: 0.3rem;
          text-align: center;
          margin-right: 0.15rem;
          font-size: 0.2rem;
          color: #fff;
          flex-shrink: 0;
        }
        .newstitle {
          flex: 1;
          overflow: hidden;
          font-size: 0.2rem;
          line-height: 0.3rem;
          color: #fff;
        }
      }
    }
  }
  .slide-box {
    .slide-box-content {
      width: 8rem;
      padding: 0 0.4rem;
      .title {
        font-size: 0.32rem;
        line-height: 1.4;
        font-weight: 600;
        padding: 0.6rem 0 0.2rem 0;
      }
      .detail {
        line-height: 1.8;
        font-size: 0.2rem;
        img {
          max-width: 100%;
        }
        p {
          margin: 1em 0;
        }
      }
    }
  }
  .footerslide {
    .btns {
      width: 8rem;
    }
  }
}
</style>
